<div class="toast-wrapper" *ngIf="toast$ | async as toast">
  <div class="toast d-flex justify-content-between" [ngClass]="toast.type">

    <div class="d-flex align-items-center">
      <div class="icon">
        {{ icon(toast.type) }}
      </div>

      <div class="content">
        <div class="title">{{ toast.title }}</div>
        <div class="message">{{ toast.message }}</div>
      </div>
    </div>

    <button type="button" class="close" (click)="close()">×</button>

    <!-- Progress bar recreated every toast -->
    <div class="progress-bar" [style.animationDuration.ms]="duration" [attr.data-key]="progressKey">
    </div>

  </div>
</div>
